import React, { FC, useMemo } from 'react';
import { useApptRequestsWidget } from '../hooks/use-appt-requests-widget/use-appt-requests-widget';
import { RouteConfig } from './route-config';

export const ApptRequestWidgetRouter: FC = () => {
  const { route } = useApptRequestsWidget();
  const component = useMemo(() => RouteConfig.find((x) => x.path == route?.path)?.component, [route]);

  return <>{component && React.createElement(component, route?.props)}</>;
};
